import { useMediaQuery, useTheme } from '@mui/material'

export const useIsMobileLandscape = (): boolean => {
  return useMediaQuery('@media only screen and (max-height: 575.98px) and (orientation: landscape)')
}

export const useIsMobile = (): boolean => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))
  const isMobileLandscape = useIsMobileLandscape()
  return downSm || isMobileLandscape
}
